import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
export function Disclaimer() {
  return <section className="py-16 px-6 bg-cosmic-dark" data-id="element-146">
      <div className="container mx-auto max-w-4xl" data-id="element-147">
        <AnimatedSection data-id="element-148">
          <div className="bg-cosmic-darker border border-gold-primary border-opacity-20 rounded-lg p-8" data-id="element-149">
            <h3 className="text-xl font-serif font-semibold text-gold-light mb-4" data-id="element-150">
              Aviso Legal
            </h3>
            <div className="text-gray-400 text-sm leading-relaxed space-y-3" data-id="element-151">
              <p data-id="element-152">
                LOS 12 es una experiencia digital de exploración simbólica y
                arquetípica. Todo el contenido se ofrece con fines de
                entretenimiento, reflexión personal y crecimiento interno.
              </p>
              <p data-id="element-153">
                Este producto NO ofrece asesoramiento médico, legal, financiero
                ni psicológico profesional. No reemplaza la consulta con
                profesionales calificados en ninguna de estas áreas.
              </p>
              <p data-id="element-154">
                Al adquirir cualquier producto de LOS 12, aceptas que comprendes
                su naturaleza simbólica y que lo utilizarás como herramienta de
                autoconocimiento, no como guía para decisiones críticas de vida.
              </p>
              <p className="pt-3 border-t border-gray-700" data-id="element-155">
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}